import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter, Switch, Redirect, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup/";
import Terms from "../pages/Terms/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Gerenciamento from "../pages/Gerenciamento/";
import Perfis from "../pages/Perfis/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Clientes from "../pages/Clientes/";
import ClienteDetalhes from "../pages/Clientes/ClienteDetalhes";
import ClienteReport from "../pages/ClienteReport/";
import ReportPrintPage from "../pages/ReportPrintPage/";
import ClienteResumo from "../pages/ClienteResumo/";
import SystemUsageReport from "../pages/SystemUsageReport/";
import Pedidos from "../pages/Pedidos/";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import TagPhrases from "../pages/TagPhrases/";
import ForbiddenWords from "../pages/ForbiddenWords/";
import ForbiddenWordsReport from "../pages/ForbiddenWordsReport/";
import TicketRatings from "../pages/TicketRatings/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
// import Companies from "../pages/Companies/";
import QuickMessages from "../pages/QuickMessages/";
import DocumentTemplates from "../pages/DocumentTemplates/";
import DocumentTemplateEditorPage from "../pages/DocumentTemplates/DocumentTemplateEditorPage";
import Kanban from "../pages/Kanban";
import KanbanBoard from "../pages/KanbanBoard";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { SettingsProvider } from "../context/Settings/SettingsContext";
import { MutedContactsProvider } from "../context/MutedContacts/MutedContactsContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { CallProvider } from "../context/Call/CallContext";
import Route from "./Route";
import Schedules from "../pages/Schedules";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import ToDoList from "../pages/ToDoList/";
import Subscription from "../pages/Subscription/";
import Files from "../pages/Files/";
import Prompts from "../pages/Prompts";
import QueueIntegration from "../pages/QueueIntegration";
import ForgetPassword from "../pages/ForgetPassWord/"; // Reset PassWd
import ErrorBoundary from "../components/ErrorBoundary";
import Agenda from "../pages/Agenda";
import AttendanceMonitor from "../pages/AttendanceMonitor";
import BackdropLoading from "../components/BackdropLoading";
import MessageTemplates from "../pages/MessageTemplates";
import Catalog from "../pages/Catalog";
import PublicConnectionPage from "../pages/PublicConnection";
import ConnectionsDiag from "../pages/ConnectionsDiag";
import FollowUpDashboard from "../pages/FollowUpDashboard";
import TicketsConference from "../pages/TicketsConference";
import MessagesReport from "../pages/MessagesReport";
import SolicitacoesDesenvolvimento from "../pages/SolicitacoesDesenvolvimento";
import PendingMessages from "../pages/PendingMessages";

// Componente que só renderiza o conteúdo privado se estiver autenticado
const PrivateRoutes = ({ showCampaigns }) => {
  const { isAuth, loading } = useContext(AuthContext);
  const location = useLocation();
  const isFollowupDashboardRoute = location.pathname === "/followup-dashboard";
  const isReportPrintRoute = location.pathname === "/report-print";

  // Se está carregando, mostra loading e não renderiza componentes filhos
  if (loading) {
    return <BackdropLoading />;
  }

  // Se não está autenticado, redireciona para login
  if (!isAuth) {
    return <Redirect to="/login" />;
  }

  // Só renderiza os componentes filhos quando está autenticado
  if (isFollowupDashboardRoute) {
    return (
      <WhatsAppsProvider>
        <ErrorBoundary>
          <Route exact path="/followup-dashboard" component={FollowUpDashboard} isPrivate />
        </ErrorBoundary>
      </WhatsAppsProvider>
    );
  }

  if (isReportPrintRoute) {
    return (
      <ErrorBoundary>
        <Route exact path="/report-print" component={ReportPrintPage} isPrivate />
      </ErrorBoundary>
    );
  }

  return (
    <WhatsAppsProvider>
      <CallProvider>
        <LoggedInLayout>
          <ErrorBoundary>
            <Route exact path="/" component={Dashboard} isPrivate />
            <Route
              exact
              path="/tickets/:ticketId?"
              component={TicketResponsiveContainer}
              isPrivate
            />
            <Route
              exact
              path="/pending-messages"
              component={PendingMessages}
              isPrivate
            />
            <Route
              exact
              path="/connections"
              component={Connections}
              isPrivate
            />
            <Route
              exact
              path="/message-templates"
              component={MessageTemplates}
              isPrivate
            />
            <Route exact path="/catalog" component={Catalog} isPrivate />
            <Route
              exact
              path="/quick-messages"
              component={QuickMessages}
              isPrivate
            />
            <Route
              exact
              path="/document-templates"
              component={DocumentTemplates}
              isPrivate
            />
            <Route
              exact
              path="/document-templates/editor/:templateId?"
              component={DocumentTemplateEditorPage}
              isPrivate
            />
            <Route
              exact
              path="/todolist"
              component={ToDoList}
              isPrivate
            />
            <Route
              exact
              path="/schedules"
              component={Schedules}
              isPrivate
            />
            <Route exact path="/tags" component={Tags} isPrivate />
            <Route exact path="/tag-phrases" component={TagPhrases} isPrivate />
            <Route exact path="/forbidden-words" component={ForbiddenWords} isPrivate />
            <Route
              exact
              path="/forbidden-words-report"
              component={ForbiddenWordsReport}
              isPrivate
            />
            <Route exact path="/avaliacoes" component={TicketRatings} isPrivate />
            <Route exact path="/contacts" component={Contacts} isPrivate />
            <Route exact path="/clientes" component={Clientes} isPrivate />
            <Route exact path="/clientes/:clienteId/resumo" component={ClienteResumo} isPrivate />
            <Route exact path="/clientes/:clienteId" component={ClienteDetalhes} isPrivate />
            <Route exact path="/cliente-report" component={ClienteReport} isPrivate />
            <Route exact path="/usage-report" component={SystemUsageReport} isPrivate />
            <Route exact path="/attendance-monitor" component={AttendanceMonitor} isPrivate />
            <Route exact path="/pedidos" component={Pedidos} isPrivate />
            <Route exact path="/followup" component={Agenda} isPrivate />
            <Route exact path="/tickets-conference" component={TicketsConference} isPrivate />
            <Route exact path="/messages-report" component={MessagesReport} isPrivate />
            <Route exact path="/desenvolvimento" component={SolicitacoesDesenvolvimento} isPrivate />
            <Route exact path="/helps" component={Helps} isPrivate />
            <Route exact path="/users" component={Users} isPrivate />
            <Route exact path="/files" component={Files} isPrivate />
            <Route exact path="/prompts" component={Prompts} isPrivate />
            <Route exact path="/queue-integration" component={QueueIntegration} isPrivate />

            <Route
              exact
              path="/messages-api"
              component={MessagesAPI}
              isPrivate
            />
            <Route
              exact
              path="/settings"
              component={Settings}
              isPrivate
            />

            <Route
              exact
              path="/gerenciamento"
              component={Gerenciamento}
              isPrivate
            />

            <Route
              exact
              path="/perfis"
              component={Perfis}
              isPrivate
            />
            <Route 
              exact
              path="/kanban"
              component={Kanban}
              isPrivate
            />
            <Route 
              exact
              path="/kanban-board"
              component={KanbanBoard}
              isPrivate
            />
            <Route
              exact
              path="/financeiro"
              component={Financeiro}
              isPrivate
            />
            <Route exact path="/queues" component={Queues} isPrivate />
            <Route
              exact
              path="/announcements"
              component={Annoucements}
              isPrivate
            />
            <Route
              exact
              path="/subscription"
              component={Subscription}
              isPrivate
            />
            <Route exact path="/chats/:id?" component={Chat} isPrivate />
            {showCampaigns && (
              <>
                <Route
                  exact
                  path="/contact-lists"
                  component={ContactLists}
                  isPrivate
                />
                <Route
                  exact
                  path="/contact-lists/:contactListId/contacts"
                  component={ContactListItems}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns"
                  component={Campaigns}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaign/:campaignId/report"
                  component={CampaignReport}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaigns-config"
                  component={CampaignsConfig}
                  isPrivate
                />
              </>
            )}
          </ErrorBoundary>
        </LoggedInLayout>
      </CallProvider>
    </WhatsAppsProvider>
  );
};

// Primeiro segmento das rotas reservadas do painel. Um "apelido" (link curto)
// de conexão pública NUNCA pode colidir com estes — mantido em sincronia com o
// RESERVED_SLUGS do backend (helpers/resolvePublicConnection.ts).
const RESERVED_ROOT_SEGMENTS = new Set([
  "login", "signup", "forgetpsw", "connection", "connections", "connections-diag",
  "tickets", "pending-messages", "message-templates", "quick-messages", "catalog",
  "document-templates", "todolist", "schedules", "tags", "tag-phrases", "forbidden-words",
  "forbidden-words-report", "avaliacoes", "contacts", "clientes",
  "cliente-report", "usage-report", "attendance-monitor", "pedidos", "followup",
  "followup-dashboard", "tickets-conference", "messages-report", "desenvolvimento", "helps", "users",
  "files", "prompts", "queue-integration", "messages-api", "settings", "gerenciamento", "perfis",
  "kanban", "kanban-board", "financeiro", "queues", "announcements", "subscription",
  "chats", "report-print", "contact-lists", "campaigns", "campaign",
  "campaigns-config", "dashboard", "api", "public-connection", "public", "termos"
]);

// Decide, na raiz do domínio, entre a página pública de conexão (quando a URL é
// um apelido de segmento único, ex.: /sniperCMS) e o app privado. Assim o link
// curto personalizado funciona sem sombrear nenhuma tela interna.
const RootDispatcher = ({ showCampaigns }) => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);
  const first = (segments[0] || "").toLowerCase();

  if (segments.length === 1 && !RESERVED_ROOT_SEGMENTS.has(first)) {
    // Reaproveita PublicConnectionPage: o apelido chega como :hash e o backend
    // resolve tanto o hash criptografado quanto o apelido.
    return <Route exact path="/:hash" component={PublicConnectionPage} />;
  }

  return <PrivateRoutes showCampaigns={showCampaigns} />;
};

const Routes = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <MutedContactsProvider>
          <SettingsProvider>
            <TicketsContextProvider>
              <Switch>
                <Route exact path="/login" component={Login} />
                <Route exact path="/signup" component={Signup} />
                <Route exact path="/termos" component={Terms} />
                <Route exact path="/forgetpsw" component={ForgetPassword} />
                <Route exact path="/connection/:hash" component={PublicConnectionPage} />
                <Route exact path="/connections-diag" component={ConnectionsDiag} />
                {/* Catch-all: RootDispatcher decide entre a página pública (apelido
                    curto na raiz) e o app privado, sem sombrear rotas internas. */}
                <Route path="/" render={() => <RootDispatcher showCampaigns={showCampaigns} />} />
              </Switch>
              <ToastContainer autoClose={3000} />
            </TicketsContextProvider>
          </SettingsProvider>
        </MutedContactsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
